import React, { useState, useEffect, useContext } from "react";
import {
  Grid,
  InputLabel,
  Switch,
  Typography,
  withStyles,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
// import Button from "@firefly/button";
import { getUsers } from "../../../../API/User";
import { updateAllocation } from "../../../../API/Check";
import LoadingIndicator from "../../../../Component/LoadingIndicator";
import ModalDialogContext from "../../../../Context/ModalDialog/ModalDialogContext";
import SearchableSelect from "../../../../Component/Forms/SearchableSelect";
import TextField from "../../../../Component/Forms/TextField";
import { validateJllEmail } from "../../../../Utilities/Functions";
import styles from "./styles";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../../Component/CustomButton";

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const AllocateRequest = (props) => {
  const { classes, isOpen, request, onSubmit, onClose, user } = props;

  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState();
  const [selfAllocated, setSelfAllocated] = useState();
  const [allocateToSelf, setAllocateToSelf] = useState(false);
  const [groupUser, setGroupUser] = useState("");
  const [otherUserName, setOtherUserName] = useState("");
  const [otherUserEmail, setOtherUserEmail] = useState("");
  const [userError, setUserError] = useState();
  const [emailError, setEmailError] = useState();
  const [userNameError, setUserNameError] = useState();

  const [isLoading, setIsLoading] = useState(true);
  const [isCreating, setCreating] = useState(false);

  const { showMessage, showErrorMessage } = useContext(ModalDialogContext);
  const { t } = useTranslation();

  useEffect(() => {
    const loadUsers = async () => {
      try {
        const result = await getUsers();
        const { data } = result;
        const { users, roles } = data;

        setUsers(
          users.map((u) => {
            return { value: u.email, label: u.username };
          }),
        );
        setRoles(
          roles.map((r) => {
            return `${r},`;
          }),
        );
        setIsLoading(false);
      } catch (error) {
        showErrorMessage({ error });
        setIsLoading(false);
      }
    };
    loadUsers();
    const allocatedUserEmail = request && request.allocated_user_email;
    setSelfAllocated(
      allocatedUserEmail === user.email ||
        (user.legacyEmail && allocatedUserEmail === user.legacyEmail),
    );
  }, []);

  const renderAllocationForm = () => {
    return (
      <Grid container direction="row" spacing={4}>
        <Grid container item md={12}>
          <Grid item md={4}>
            <Typography>{t("labels.check.allocation.typeOfCheck")}</Typography>
            <span>{request && (request.checkType || request.check_type)}</span>
          </Grid>
          <Grid item md={4}>
            <Typography>
              {t("labels.check.allocation.currentlyAllocatedTo")}
            </Typography>
            <span>
              {request && request.allocated_user_name
                ? request.allocated_user_name
                : t("labels.check.allocation.unassigned")}
              {selfAllocated ? t("labels.check.allocation.self") : ""}
            </span>
          </Grid>
        </Grid>
        <Grid container item md={12}>
          {!selfAllocated && (
            <Grid
              item
              container
              md={2}
              spacing={1}
              justify="flex-start"
              direction="column"
              alignItems="flex-start"
            >
              <Grid item>
                <Typography>
                  {t("labels.check.allocation.allocateToSelf")}
                </Typography>
              </Grid>
              <Grid item>
                <Switch
                  checked={allocateToSelf}
                  disableRipple
                  classes={{
                    switchBase: classes.switchBase,
                    thumb: classes.thumb,
                    track: classes.track,
                    checked: classes.checked,
                  }}
                  onChange={changeSelfAllocation}
                />
              </Grid>
            </Grid>
          )}
          {!selfAllocated && (
            <Grid
              item
              container
              md={1}
              justify="center"
              direction="column"
              alignItems="center"
            >
              <InputLabel className={classes.inputLabel}>
                {t("labels.common.or")}
              </InputLabel>
            </Grid>
          )}

          <Grid
            item
            container
            md={5}
            spacing={1}
            justify="flex-start"
            direction="column"
          >
            <Grid item>
              <Typography>
                {t("labels.check.allocation.selectUsersFromRoles")}
              </Typography>
              <Typography className={classes.inputLabel}>{roles}</Typography>
            </Grid>
            <Grid item>
              <SearchableSelect
                disableClearable={true}
                options={users}
                value={groupUser}
                changeHandler={groupUserChange}
                disabled={allocateToSelf}
              />
              {userError && (
                <span className={classes.errorText}>{userError}</span>
              )}
            </Grid>
          </Grid>

          <Grid
            item
            container
            md={selfAllocated ? 3 : 1}
            justify="center"
            direction="column"
            alignItems="center"
          >
            <InputLabel className={classes.inputLabel}>
              {t("labels.common.or")}
            </InputLabel>
          </Grid>

          <Grid
            item
            container
            md={selfAllocated ? 4 : 3}
            spacing={1}
            justify="flex-start"
            direction="column"
            alignItems="flex-start"
          >
            <Grid item>
              <Typography>
                {t("labels.check.allocation.allocateToOthers")}
              </Typography>
            </Grid>
            <Grid item>
              <TextField
                label={t("labels.check.allocation.userEmail")}
                type="text"
                initialValue={otherUserEmail}
                placeholder={t("labels.check.allocation.enterEmail")}
                onChange={otherUserEmailChange}
                disabled={allocateToSelf}
              />
              {emailError && (
                <span className={classes.errorText}>{emailError}</span>
              )}
            </Grid>
            <Grid item>
              <TextField
                label={t("labels.check.allocation.userName")}
                type="text"
                initialValue={otherUserName}
                placeholder={t("labels.check.allocation.enterUserName")}
                onChange={otherUserNameChange}
                disabled={allocateToSelf}
              />
              {userNameError && (
                <span className={classes.errorText}>{userNameError}</span>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderLoadingIndicator = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <LoadingIndicator />
      </div>
    );
  };

  const changeSelfAllocation = (e) => {
    const checked = e.target.checked;
    setAllocateToSelf(checked);
    if (checked) {
      setGroupUser(null);
      setOtherUserName("");
      setOtherUserEmail("");
      setUserError();
      setEmailError();
      setUserNameError();
    }
    setIsLoading(false);
  };

  const groupUserChange = (user) => {
    setGroupUser(user);
    if (user) {
      setOtherUserName("");
      setOtherUserEmail("");
    }
  };

  const otherUserNameChange = (name) => {
    setOtherUserName(name);
    if (name) {
      setGroupUser();
    }
  };

  const otherUserEmailChange = (email) => {
    setOtherUserEmail(email);
    if (email) {
      setGroupUser();
    }
  };

  const handleClose = () => {
    onClose();
  };

  const handleSubmit = async () => {
    setUserError();
    setEmailError();
    setUserNameError();
    if (!allocateToSelf) {
      if (!groupUser && !otherUserEmail) {
        setUserError(t("messages.check.allocation.userError"));
        return;
      }
      if (
        !groupUser &&
        (!otherUserEmail || !validateJllEmail(otherUserEmail))
      ) {
        setEmailError(t("messages.check.allocation.emailError"));
        return;
      }
    }
    setIsLoading(true);
    setCreating(true);
    let allocatedUsername;
    let allocatedEmail;
    if (allocateToSelf) {
      allocatedUsername = user.name;
      allocatedEmail = user.email;
    } else if (groupUser) {
      allocatedUsername = groupUser.label;
      allocatedEmail = groupUser.value;
    } else {
      allocatedUsername = otherUserName || parseUserName(otherUserEmail);
      allocatedEmail = otherUserEmail;
    }
    try {
      await updateAllocation({
        requestId: request.id,
        allocatedUsername,
        allocatedEmail,
      });
      showMessage({ message: t("messages.check.allocation.requestAllocated") });
      onSubmit();
    } catch (error) {
      showErrorMessage({ error });
    }
    setCreating(false);
    setIsLoading(false);
  };

  const parseUserName = (email) => {
    const username = email.split("@")[0];
    if (username.indexOf(".") > -1) {
      return username.replace(".", " ");
    } else {
      return username.substring(0, 1) + " " + username.substring(1);
    }
  };

  return (
    <Dialog
      disableBackdropClick
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      fullWidth={true}
      scroll="paper"
      maxWidth="md"
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        <Typography className={classes.panelTitle}>
          {t("labels.check.allocation.allocateRequest")}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        {isLoading ? renderLoadingIndicator() : renderAllocationForm()}
      </DialogContent>
      <DialogActions>
        <CustomButton variant="secondary" isDisabled={isCreating} onClick={handleClose}>
          {t("labels.common.cancel")}
        </CustomButton>
        <CustomButton 
          variant="primary" 
          loadingText={t("labels.check.allocation.allocating")}
          isLoading={isCreating}
          isDisabled={isCreating}
          onClick={handleSubmit}
        >
          {t("labels.check.allocation.allocate")}
        </CustomButton>

        {/* <Button
          label={t("labels.common.cancel")}
          theme="secondary"
          isDisabled={isCreating}
          onClick={handleClose}
        /> */}
        {/* <Button
          label={t("labels.check.allocation.allocate")}
          theme="primary"
          loadingText={t("labels.check.allocation.allocating")}
          isLoading={isCreating}
          isDisabled={isCreating}
          onClick={handleSubmit}
        /> */}
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles, { withTheme: true })(AllocateRequest);
